const Logotipo = () => {
    return require("assets/img/logo-white.png");
}

const LogoOperadora = () => {
    return require("assets/img/logo-operadora.jpg");
}


export {Logotipo,LogoOperadora}